import Image from "next/image";
import { Resource } from "graphql/generated-types";

import clsx from "clsx";
import ChevronLink from "./ChevronLink";

const Resource = ({
	resource: { title, resourceType, image, url },
	featured = false,
}: {
	resource: Resource;
	featured?: boolean;
}) => {
	return (
		<div>
			<div className={clsx("relative mb-7", featured ? "h-96" : "h-72")}>
				<Image
					className="absolute h-full w-full rounded object-cover"
					src={image?.rendition?.url!}
					width={image?.rendition?.width}
					height={image?.rendition?.height}
					alt={image?.rendition?.image.title!}
				/>
			</div>
			<div>
				<div className="text-xxs text-blue-lightest mb-2 font-bold uppercase leading-4 tracking-wide lg:text-sm">
					{resourceType}
				</div>
				<div className="mb-10 text-base leading-tight lg:text-lg">{title}</div>
				<ChevronLink url={url}>Read more</ChevronLink>
			</div>
		</div>
	);
};

export default Resource;
